import { FileUploadData, MatchingDataInterface, UploadKindEnum } from "@finway-group/shared/lib/models"
import axios from "axios"
import fileDownload from "js-file-download"

const FileService = {
    upload: async (file: File, kind: string, onProgress?: any) => {
        const { formData, config } = prepareFileUpload(file, onProgress)
        formData.append("kind", kind)
        const { data } = await axios.post(`/files`, formData, config)
        return data as FileUploadData
    },

    uploadMultiple: async (files: File[], kind: UploadKindEnum, onProgress?: any) => {
        const { formData, config } = prepareFilesUpload(files, onProgress)
        formData.append("kind", kind.toString())
        const { data } = await axios.post(`/files/multiple`, formData, config)
        return data as FileUploadData[]
    },

    uploadMatchingCSV: async (file: File, onProgress?: any) => {
        const { formData, config } = prepareFileUpload(file, onProgress)
        formData.append("kind", UploadKindEnum.CSV_MATCHING.toString())
        const { data } = await axios.post(`/matching/determine`, formData, config)
        return data as MatchingDataInterface[]
    },

    export: (filter: string, shouldSkipUpdate = false, subjectLines?: any) => axios.post(`export/expenses?${filter}`, { subjectLines, shouldSkipUpdate }),

    downloadDataImportSpreadSheetTemplate: (language: string, fileName: string) => axios.get(`/files/${language}%2F${fileName}?isTemplate=true`, { responseType: "arraybuffer" }),

    downloadImportResultLogSpreadsheet: (importResultId: string) => axios.get(`/files/import-result/${importResultId}`, { responseType: "arraybuffer" }),

    downloadFile: (url: string) => axios.post(`/files/download/url`, { url }, { responseType: "arraybuffer" }),

    getSignedUrl: (url: string) => axios.post(`/files/signed-url`, { url }),

    exportExpenseSummary: async (id: string, language: string) => {
        const {
            data: { pdfUrl },
        } = await axios.post(`/export/expenses/${id}/summary`, { language })
        const { data } = await FileService.downloadFile(pdfUrl)

        const fileName = pdfUrl.substring(pdfUrl.lastIndexOf("/") + 1)
        fileDownload(data, `${fileName}.pdf`)
    },
}

export const prepareFileUpload = (file: File, onProgress?: any) => {
    return prepareFilesUpload([file], onProgress)
}

export const prepareFilesUpload = (files: File[], onProgress?: any) => {
    const formData = new FormData()
    let config = {
        headers: { "Content-type": "multipart/form-data" },
        onUploadProgress: (event: any) => {},
    }

    if (onProgress) {
        config = {
            ...config,
            onUploadProgress: (event: any) => {
                onProgress({ percent: (event.loaded / event.total) * 100 })
            },
        }
    }

    files.forEach((file) => formData.append("uploadFile", file))
    return { formData, config }
}

export default FileService
